import { ActivatedRoute, Router } from "@angular/router";
// import { FormControl ,FormGroup, Validators } from '@angular/forms';
// import {HttpErrorResponse} from '@angular/common/http';
// import { NgxSpinnerService } from 'ngx-spinner';
import { ServicesService } from "../services/services.service";
import { environment } from "../../environments/environment";
// import swal from 'sweetalert2';
import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import swal from "sweetalert2";

@Component({
  selector: "app-loadsheet",
  templateUrl: "./loadsheet.component.html",
  styleUrls: ["./loadsheet.component.css"]
})
export class LoadsheetComponent implements OnInit {
  //static's valiable
  fields: any = [];
  listData: any = [];
  cid: string;
  clientName: string;
  routePath: string;

  public loading = false;
  isLoader: boolean = false;
  public show: boolean = false;
  apiBaseUrl = environment.apiBaseUrl;
  spinLoader = {
    filter: false,
    delete: []
  };

  isListData = false;
  isListDataEmpty = false;
  isOnePage = false;
  backDiv = false;
  isCid = false;
  cname: any = "";
  role_id;


  constructor(private route: ActivatedRoute, private router: Router, private _services: ServicesService) {
    this.route.queryParams.subscribe(params => {
      this.cid = params["cid"];
      this.cname = params["cname"];
    });
  }

  ngOnInit() {
    const userData = JSON.parse(localStorage.getItem("userData"));
    this.role_id = userData.role_id;

    if (this.cid != undefined) {
      this.backDiv = true;
      this.isCid = true;
      this.clientName = this.cname;
      this.getPageRequest();
    } else {
      this.getPageRequest();
    }

    this.getOrderProjectList();

    this.fields = [
      {
        field: "loadsheet_no",
        title: "LoadSheet Number",
        width: "15%",
        code: true,
        sort: true
      },
      {
        field: "client_name",
        title: "Client Name",
        width: "15%",
        code: true,
        sort: true
      },
      {
        field: "created_at",
        title: "Created Date",
        width: "15%",
        code: false,
        sort: false
      },
      {
        field: "schedule_date",
        title: "Scheduled Date",
        width: "15%",
        code: false,
        sort: false
      },
      {
        field: "loaded_timestamp",
        title: "Loaded Date (M)",
        width: "15%",
        code: false,
        sort: false
      },
      {
        field: "loadsheet_status",
        title: "Loadsheet status",
        width: "10%",
        code: false,
        sort: false
      }
    ];
  }

  resetSearchField() {
    this.searchFields = [""];
    this.searchProjectId = "";
    this.getPageRequest();
  }

  getSearchRequest() {
    this.spinLoader["filter"] = true;
    this.getPageRequest();
  }

  sortType: string = "";
  sortField: string = "";
  oldField: string;
  sortingData = {
    field: "",
    type: ""
  };

  sortBy(field, event) {
    this.spinLoader["filter"] = true;

    this.oldField = this.oldField != field ? this.oldField : field;

    if (typeof this.oldField !== "undefined") {
      ////console.log(document.getElementById('fa-'+this.oldField));
      document.getElementById("fa-" + this.oldField).classList.remove("fa-sort-up");
      document.getElementById("fa-" + this.oldField).classList.remove("fa-sort-down");
      document.getElementById("fa-" + this.oldField).classList.add("fa-sort");
    }

    event.target.classList.add("fa");

    this.sortField = field;
    this.sortType = this.sortType == "desc" ? "asc" : "desc";

    switch (this.sortType) {
      case "desc":
        {
          event.target.classList.remove("fa-sort-up");
          event.target.classList.add("fa-sort-down");
          this.oldField = field;
        }
        break;
      case "asc":
        {
          event.target.classList.remove("fa-sort-down");
          event.target.classList.add("fa-sort-up");
          this.oldField = field;
        }
        break;
      default: {
        event.target.classList.add("fa-sort");
      }
    }

    this.sortingData = {
      field: this.sortField,
      type: this.sortType
    };

    this.getPageRequest();
  }
  /*------------------------------Table with Sorting Ends Here--------------------------*/

  /*------------------------------Pagination Integration Starts Here------------------------*/
  currentPage: number = 1;
  loader: boolean = false;
  paginate = {
    last_page: 1
  };
  searchFields = [];
  pages: any;
  //   listData = [];
  editData: Object = {};

  previousPage() {
    if (this.currentPage == 1) {
      return;
    }

    this.currentPage = this.currentPage - 1;
    ////console.log(this.currentPage);return;
    this.getPageRequest();
  }

  nextPage() {
    if (this.paginate.last_page - 1 < this.currentPage) {
      return;
    }

    this.currentPage++;
    //console.log(this.currentPage);
    this.getPageRequest();
  }

  changePage() {
    this.currentPage = this.currentPage;
    ////console.log(this.currentPage);return;
    this.getPageRequest();
  }

  getPages(n) {
    if (n > 1) {
      this.isOnePage = true;
    } else {
      this.isOnePage = false;
    }
    var data = [];

    for (var i = 1; i <= n; i++) {
      data.push(i);
    }
    this.pages = data;
    ////console.log(this.pages);
  }

  /*------------------------------Pagination Integration Starts Here------------------------*/
  routeData: string;
  totalData: any;
  getPageRequest() {
    this.spinLoader["filter"] = true;
    this.isListData = true;
    this.isListDataEmpty = false;

    let data;
    this.routeData = "get-loadsheet-list";
    switch (this.routeData) {
      case "get-loadsheet-list": {
        data = {
          page: this.currentPage,
          search: {
            loadsheet_no: this.searchFields["loadsheet_no"],
            client_name: this.searchFields["client_name"]
          },
          sort: this.sortingData,
          project_order_id: this.searchProjectId ? this.searchProjectId : "",
          client_id: this.cid
        };
        break;
      }
    }

    this.loading = true;
    const token = localStorage.getItem("userToken");
    this._services.requestCreator(data, this.routeData, token).subscribe((result: any) => {
      if (this._services.checkToken(result.status)) {
        this.spinLoader["filter"] = false;
        this.isListData = false;
        this.listData = [{ client_name: "" }];
        this.listData = result.result;
        this.totalData = result.paginate.total;
        this.paginate = result.paginate;

        this.currentPage = result.paginate.current_page;
        if (this.listData.length == 0) {
          this.isListDataEmpty = true;
        } else {
          this.cid ? (this.clientName = this.listData[0].client_name) : "";
        }

        if (result.paginate.current_page > result.paginate.last_page) {
          this.currentPage = result.paginate.last_page;
        }
        this.listData = this.listData.filter((eachLoadsheet) => {
          return eachLoadsheet.loadsheet_no && eachLoadsheet.loadsheet_no != ""
        })
        this.getPages(this.paginate.last_page);
      }
    });

    return true;
  }

  orderProjectList: any;
  getOrderProjectList() {
    let data;
    this.routeData = "get-project-order-list";

    switch (this.routeData) {
      case "get-project-order-list": {
        data = {
          page: this.currentPage,
          search: {
            project_name: this.searchFields["project_name"]
          }
        };
        break;
      }
    }
    const token = localStorage.getItem("userToken");
    this._services.requestCreator(data, this.routeData, token).subscribe((result: any) => {
      if (this._services.checkToken(result.status)) {
        // //console.log(result.result);
        this.orderProjectList = result.result;
        // //console.log(this.orderProjectList);
      }
    });

    return true;
  }

  searchProjectId: any = "";
  searchProjectOrder(event) {
    //console.log(event.target.value);
    this.searchProjectId = event.target.value;
    this.getPageRequest();
  }
}
